import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import { useStyles } from './styles';

export interface IDialogTitleProps {
  id?: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = (props: IDialogTitleProps) => {
  const classes = useStyles();
  const { children, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {children}
      <IconButton aria-label='close' className={classes.closeButton} onClick={onClose} size='small'>
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
};

export default DialogTitle;
